import { render } from "./EnvironmentsList.vue?vue&type=template&id=0127bca9&scoped=true"
import script from "./EnvironmentsList.vue?vue&type=script&lang=js"
export * from "./EnvironmentsList.vue?vue&type=script&lang=js"

import "./EnvironmentsList.vue?vue&type=style&index=0&id=0127bca9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0127bca9"]])

export default __exports__